import lookupValidator, { setMessages } from 'ember-changeset-validations'
import { type IntlService } from 'ember-intl'
import type { ValidatorAction } from 'ember-changeset/types'

/**
 * Validation action created on each change made to a changeset
 *
 * [ember-changeset validation]{@link https://github.com/poteto/ember-changeset#validation-signature}
 */

/**
 * Converts ember-changeset-validations to a validation function for ember-changeset
 * with translated validation messages from the intl service
 *
 * [Prior art from]{@link https://github.com/poteto/ember-changeset-validations/issues/94#issuecomment-416970126}
 */
export default (validationMap = {}, options: { intl: IntlService }): ValidatorAction => {
  const { intl } = options
  /* Uses default messages (like "{description} must be a number") but provides the description as a translation of the
   * key. eg gradePosition -> Year (or Grade)
   */
  setMessages({
    /* can place message overrides in here if you need - eg, from ember-intl.
     *
     * number: intl.t('validation.changeset.messages.inclusion'), // "{description} must be a number"
     */
    getDescriptionFor(key = '') {
      return intl.t(`validation.changeset.keys.${key}`)
    },
  })
  /**
   * Validation function for ember-changeset
   */
  const lookup: ValidatorAction = (validatorArgs) => {
    const validator = lookupValidator(validationMap)
    if (!validator) throw new Error('could not lookup validator')
    return validator(validatorArgs)
  }
  return lookup
}
